import config from './config'
import Create from './create'
import Edit from './edit'

export default {
  ...config,
  config,
  edit: Edit,
  create: Create,
}
